// Candidate free-text responses have one product-wide floor, not a cap: an answer
// is either left empty or written to at least this many words. Character length is
// intentionally unrestricted, and legacy API word_limit values do not override
// this rule in the assessment-taking experience.
export const OPEN_ENDED_RESPONSE_MIN_WORDS = 200;

export const countResponseWords = (value: string): number =>
  value.trim() ? value.trim().split(/\s+/).length : 0;

/**
 * Skipping a question is always allowed, so an empty answer clears the minimum.
 * Only a part-written one fails — that is the case the floor exists to catch.
 */
export const meetsOpenEndedResponseMinimum = (
  value: string | null | undefined,
): boolean => {
  const wordCount = countResponseWords(value || '');
  return wordCount === 0 || wordCount >= OPEN_ENDED_RESPONSE_MIN_WORDS;
};
